import { useEffect, useRef, useState } from 'react';
import { useHistory, withRouter, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";

import Header, { NavList } from "@/components/Base/header";
import Contact from "@/components/Base/contact";
import Footer from "@/components/Base/footer";
import Subscribe from "@/components/Base/subscribe";
import SvgsOthers from "@/components/svgs/others";
import { newPath } from '@/utils/index'
import { Root } from './css'


const Index = ({ store }) => {
  const { isMobile } = store.common;
  const history = useHistory();

  useEffect(() => {
    
  }, [])

  return (
    <Root className={`${isMobile ? 'mobile' : ''}`}>
      <Header currentName={NavList[2].name} />
      <div className="content">
        <div className="apply">
          <h1>Dmail Ambassador Program</h1>
          <div className="desc">
            <p>After applying for this program, you'll be on the waitlist as Ambassador Candidate.</p>
            <p>It is a volunteer program for those who want to support Dmail's community growth.</p>
          </div>
          <div className="actions">
            <a className="filled-red to-apply" onClick={() => history.push(`${newPath}/apply`)}>Apply Now</a>
          </div>
        </div>
        <div className="guidelines">
          <div className="center">
            <h2>Guidelines</h2>
            <div className="desc">
              <p>Location: Global (Remote Online Work) </p>
              <p>Selection Criteria: Passionate about blockchain and Web 3.0.</p>
            </div>
            <div className="card">
              <dl>
                <dt><SvgsOthers type="criteria" width={isMobile ? 20 : 30} height={isMobile ? 16 : 24} />Criteria</dt>
                <dd>
                  <p>Having a passion of Web 3.0, our vision and mission.</p>
                  <p>Very active and engaging on Discord, Telegram, and Twitter.</p>
                  <p>Experience of community engagement on social media & meetups.</p>
                  <p>Experience of working with Dfinity ecosystem.</p>
                  <p>Content creation skills.</p>
                </dd>
              </dl>
              <dl>
                <dt><SvgsOthers type="benefits" width={isMobile ? 18 : 26} />Benefits</dt>
                <dd>
                  <p>Competitive salary and rewards incentives.</p>
                  <p>Commission from the Dmail presale in your area.</p>
                  <p>Invitations to our events as a privileged guest organizer.</p>
                  <p>Access to Dmail Network alums.</p>
                  <p>You may visit any of our offices at any time.</p>
                  <p>Your feedback has a chance to be written to the Dmail Roadmap.</p>
                  <p>Limited edition swags.</p>
                </dd>
              </dl>
              <dl>
                <dt><SvgsOthers type="evaluation" width={isMobile ? 16 : 24} height={isMobile ? 17 : 25} />Evaluation & Priority</dt>
                <dd>
                  <p>We will observe your engagement on Discord, or Telegram.</p>
                  <p>We will evaluate your attitude towards people.</p>
                  <p>We value the size of your community that you can reach.</p>
                  <p>We value the quality of your future referrals.</p>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom">
        <div className="center">
          <Subscribe />
          <Contact />
          <Footer />
        </div>
      </div>
    </Root>
  )
}

export default withRouter(inject("store")(observer(Index)))